import { ContainerBuilder } from 'react-habitat';
export default class CustomContainerBuilder extends ContainerBuilder {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerIfPresent(operator, key) {
        const components = Array.from(document.querySelectorAll(`[data-component="${key}"]`));
        if (!components || !components.length) {
            return;
        }
        this.registerAsync(operator).as(key);
    }
}
